import { memo } from 'react';

// Compact inline SVG flags — emoji regional-indicator flags do not render
// on Windows browsers, so we draw them ourselves. All normalised to a
// 3:2 viewBox.
const flags = {
  fr: (
    <>
      <rect width="3" height="2" fill="#fff" />
      <rect width="1" height="2" fill="#0055A4" />
      <rect x="2" width="1" height="2" fill="#EF4135" />
    </>
  ),
  de: (
    <>
      <rect width="3" height="2" fill="#FFCE00" />
      <rect width="3" height="1.333" fill="#DD0000" />
      <rect width="3" height="0.667" fill="#000" />
    </>
  ),
  es: (
    <>
      <rect width="3" height="2" fill="#AA151B" />
      <rect y="0.5" width="3" height="1" fill="#F1BF00" />
    </>
  ),
  it: (
    <>
      <rect width="3" height="2" fill="#fff" />
      <rect width="1" height="2" fill="#009246" />
      <rect x="2" width="1" height="2" fill="#CE2B37" />
    </>
  ),
  pt: (
    <>
      <rect width="3" height="2" fill="#DA291C" />
      <rect width="1.2" height="2" fill="#046A38" />
      <circle cx="1.2" cy="1" r="0.34" fill="#FFE000" stroke="#fff" strokeWidth="0.06" />
    </>
  ),
  gb: (
    <>
      <rect width="3" height="2" fill="#012169" />
      <path d="M0,0 L3,2 M3,0 L0,2" stroke="#fff" strokeWidth="0.4" />
      <path d="M0,0 L3,2 M3,0 L0,2" stroke="#C8102E" strokeWidth="0.24" />
      <path d="M1.5,0 V2 M0,1 H3" stroke="#fff" strokeWidth="0.6" />
      <path d="M1.5,0 V2 M0,1 H3" stroke="#C8102E" strokeWidth="0.36" />
    </>
  ),
};

function FlagBase({ code, size = 20, className = '', style }) {
  const body = flags[code];
  if (!body) return null;
  return (
    <svg
      width={size}
      height={size * (2 / 3)}
      viewBox="0 0 3 2"
      className={`flag ${className}`}
      style={style}
      aria-hidden="true"
      role="img"
    >
      {body}
    </svg>
  );
}

export const Flag = memo(FlagBase);
